<div [@pageLoad]="pageLoadState" class=" h-[100%] relative " >
    <div
    class="gap-[40px] flex flex-col  justify-around items-center pl-[64px] pr-[64px] pt-[40px] pb-[40px] bg-[#f8fafdff] w-[100%] h-[100%] " >
    <div
        class="gap-[80px] flex flex-col w-[100%] shrink-0 justify-start items-center self-stretch grow basis-0 pt-[160px] pb-[160px]">
        <div class="gap-[40px] flex flex-col w-[100%] shrink-0 justify-start items-center self-stretch">
            <div class="gap-[16px] flex flex-col shrink-0 justify-start items-center">
                <div 
                    *ngIf="!allDaysSelected"
                    class="gap-[8px] flex flex-row shrink-0 justify-center items-center">
                    <img
                        src="assets/icons/infoSuccess.svg"
                        alt="Success information icon"
                        loading="lazy"
                        decoding="async"
                        class="w-[32px] h-[32px] shrink-0 justify-start items-start " />
                    <span
                        class="shrink-0 justify-start items-start text-[#444955ff] text-center font-normal font-['archivo'] text-[20px] leading-[22px]">
                        {{ hasWaitingList ? 'Meal and Transportation Booking Confirmed - On Waiting List for ' + waitingListDates + '.' : 'Meal and Transportation Booking Confirmed.' }}
                    </span>
                </div>
                <span
                    class=" shrink-0 justify-start items-start text-[#111215] text-center font-bold font-['archivo'] text-[24px] leading-[32px] tracking-[-0.01em]" >
                    {{ headerTitle }}
                </span>
                <span *ngIf="allDaysSelected">
                    <span
                        class="w-[674px] shrink-0 justify-start items-start text-[#444955] text-center font-normal font-['archivo'] text-[20px] leading-[100%] tracking-[-0.01em] ">
                        {{ headerSubtitle }}
                    </span>
                </span>
            </div>

            <div
                class="gap-[20px] flex flex-row w-[100%] shrink-0 justify-center items-stretch self-stretch flex-wrap px-[48px]">
                <ng-container *ngFor="let option of dateOptions; let i = index">

                <button
                    *ngIf="!option.submitted"
                    type="button"
                    (click)=" handleCardClick(i)"
                    (keydown)="handleCardKeyDown($event, i)"
                    [attr.aria-label]="'Select date ' + option.dateLabel"
                    class="flex flex-col w-[260px] cursor-pointer shrink-0 rounded-[16px] justify-start items-start focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-[#5BA5F54D] overflow-hidden"
                    [ngClass]="
                        'border-[2px] border-[#A1A4AA]'
                    ">
                    <!-- Header -->
                    <div
                        class="gap-[8px] flex flex-row w-[100%] rounded-tl-[14px] border-b-[2px] border-b-[#A1A4AA] rounded-tr-[14px] shrink-0 justify-center items-center self-stretch pl-[12px] pr-[12px] pt-[12px] pb-[12px]"
                        [ngClass]="{
                            'bg-[#f0a169ff] ': option.state === 'today',
                            'bg-[#4caf50ff] ' : option.state === 'selected',
                            'bg-[#ffffffff]': option.state === 'default'
                        }">
                        <div class="gap-[8px] flex flex-row w-[100%] shrink-0 justify-center items-center grow basis-0">
                            <span
                                class="shrink-0 justify-start items-start text-center font-normal font-['archivo'] text-[18px] uppercase leading-[32px]"
                                [ngClass]="{
                                    'text-[#ffffffff]': option.state === 'today' || option.state === 'selected',
                                    'text-[#444955ff]': option.state === 'default'
                                }">
                                {{ (option.dateValue !== todayDateValue && option.waitingListCount && option.waitingListCount > 0) ? 'Waiting List' : option.dayLabel }}
                            </span>
                            <div
                                *ngIf="option.state === 'selected' && !(option.dateValue !== todayDateValue && option.waitingListCount && option.waitingListCount > 0)"
                                class="gap-[8px] flex flex-row w-[24px] h-[24px] shrink-0 rounded-[100px] justify-end items-start pl-[4px] pr-[2px] pt-[2px] pb-[4px] bg-[#088242]">
                                <img
                                    src="assets/icons/check.svg"
                                    alt="Selected date checkmark"
                                    loading="lazy"
                                    decoding="async"
                                    class="w-[20px] h-[20px] shrink-0 justify-start items-start " />
                            </div>
                        </div>
                    </div>
                    <!-- Body -->
                    <div
                        class="gap-[8px] flex flex-col w-[100%] shrink-0 justify-start items-center self-stretch pl-[14px] pr-[14px] pt-[16px] pb-[16px] relative grow"
                        [ngClass]="{
                            'bg-[#ffffffff]': option.state === 'today' || option.state === 'default',
                            'bg-[#f2f5f7ff] ': option.state === 'selected',
                        }">
                        <span
                            class="w-[100%] shrink-0 justify-start items-start self-stretch text-[#111215ff] text-center font-bold font-['archivo'] text-[22px] leading-[26px]">
                            {{ option.dateLabel }}
                        </span>
                        <div
                            *ngIf="option.hotMenuText || option.coldMenuText"
                            class="flex flex-col w-full gap-[6px] pt-[4px] items-start text-left">
                            <span
                                *ngIf="option.hotMenuText"
                                class="w-full text-[#444955] font-['archivo'] font-normal text-[12px] leading-[16px]">
                                Hot: {{ option.hotMenuText }}
                            </span>
                            <span
                                *ngIf="option.coldMenuText"
                                class="w-full text-[#444955] font-['archivo'] font-normal text-[12px] leading-[16px]">
                                Cold: {{ option.coldMenuText }}
                            </span>
                        </div>
                        <div
                            *ngIf="option.badgeCount"
                            class="absolute bottom-0 right-0 flex flex-row items-center gap-[4px] rounded-tl-[6px] rounded-br-[12px] bg-[#f26f24] px-[8px] py-[6px] shadow-sm">
                            <svg
                                width="16"
                                height="16"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                class="shrink-0">
                                <circle cx="12" cy="12" r="10" stroke="white" stroke-width="2.5" />
                                <path d="M12 6V12L16 14" stroke="white" stroke-width="2.5" stroke-linecap="round" />
                            </svg>
                            <span
                                class="text-white font-open-sans font-bold text-[18px] leading-none">
                                {{ option.badgeCount }}
                            </span>
                        </div>
                    </div>

                    <!-- Location footer -->
                    <div
                        *ngIf="option.locationName && option.state === 'selected'"
                        class="flex flex-row w-full items-center justify-center gap-[6px] px-[12px] py-[8px] bg-[#e8f5e9] border-t border-t-[#c8e6c9]">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="shrink-0">
                            <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" fill="#2e7d32" />
                            <circle cx="12" cy="9" r="2.5" fill="white" />
                        </svg>
                        <span class="text-[#2e7d32] font-archivo font-semibold text-[12px] leading-[16px] truncate">
                            {{ option.locationName }}
                        </span>
                    </div>
                </button>
                </ng-container>
            </div>
        </div>
    </div>
    <div class="gap-[8px] flex flex-row w-[100%] shrink-0 justify-between items-start self-stretch">
        <NiButton
            variant="outlined"
            color="secondary"
            size="Large"
            label="Back"
            leadingIcon="arrowNarrowLeft"
            [px]="'[24px]'"
            [py]="'[16px]'"
            [rounded]="'[999px]'"
            border="1"
            borderColor="[#5BA5F5]"
            bg="transparent"
            (onClick)="onBackClick()"
            [styleClass]="
                'flex flex-row items-center gap-[8px] rounded-[999px] border border-[#5BA5F5] text-[#2E90FA] font-bold font-[' +
                `'archivo'] text-[18px] leading-[23px] line-height-[24px]'`">
        </NiButton>
        <div class="gap-[28px] flex flex-row shrink-0 justify-end items-center">
            <NiButton
                variant="contained"
                color="primary"
                size="large"
                label="Next"
                [px]="'[24px]'"
                [py]="'[16px]'"
                [rounded]="'[999px]'"
                bg="[#f26f24ff]"
                textColor="#ffffff"
                (onClick)="onNextClick()"
                [styleClass]="
                    'flex flex-row items-center gap-[12px] rounded-[999px] bg-[#f26f24ff] text-[#ffffffff] font-bold font-[' +
                    `'archivo'] text-[18px] leading-[23px] px-[32px] py-[12px]'`">
            </NiButton>
        </div>
    </div>
</div>
</div>
